import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
} from "@mui/material";
import useQueryState from "../../../hooks/useQueryState";
import { DEKADS, MONTHS } from "./enums";
import { useMemo } from "react";

const SelectCriticalWindow = ({
  displayName,
  season,
  dekads,
  months,
}: {
  displayName: string;
  season: string;
  dekads: string[];
  months: string[];
}) => {
  const {
    queryState: { layers },
    setQueryState,
  } = useQueryState();
  const selectedLayer = useMemo(
    () =>
      layers.find(
        (layer) => layer.displayName === displayName && layer.season === season,
      ),
    [layers],
  );

  const handleChangeMonths = (
    event: SelectChangeEvent<string>,
    index: number,
  ) => {
    if (selectedLayer) {
      const updatedMonths = selectedLayer.months;
      updatedMonths[index] = event.target.value;
      const updatedLayer = layers.filter(
        (layer) => layer.displayName !== displayName || layer.season !== season,
      );
      setQueryState({
        layers: [...updatedLayer, { ...selectedLayer, months: updatedMonths }],
      });
    } else {
      const updatedMonths = months;
      updatedMonths[index] = event.target.value;
      setQueryState({
        layers: [
          ...layers,
          { displayName, dekads, months: updatedMonths, season },
        ],
      });
    }
  };

  const handleChangeDekads = (
    event: SelectChangeEvent<string>,
    index: number,
  ) => {
    if (selectedLayer) {
      const updatedDekads = selectedLayer.dekads;
      updatedDekads[index] = event.target.value;
      const updatedLayer = layers.filter(
        (layer) => layer.displayName !== displayName || layer.season !== season,
      );
      setQueryState({
        layers: [...updatedLayer, { ...selectedLayer, dekads: updatedDekads }],
      });
    } else {
      const updatedDekads = dekads;
      updatedDekads[index] = event.target.value;
      setQueryState({
        layers: [
          ...layers,
          { displayName, months, dekads: updatedDekads, season },
        ],
      });
    }
  };

  return (
    <Stack gap={1.5}>
      <Stack sx={{ flex: 1 }} direction="row" gap={1.5}>
        <FormControl fullWidth sx={{ flex: 1 }}>
          <InputLabel id="from-month">Month</InputLabel>
          <Select
            value={selectedLayer?.months[0] ?? months[0]}
            label="Month"
            labelId="from-month"
            onChange={(e) => handleChangeMonths(e, 0)}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 150,
                },
              },
            }}
          >
            {MONTHS.map((month, i) => (
              <MenuItem key={`from-month-${month}`} value={`${i + 1}`}>
                {month}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth sx={{ flex: 1 }}>
          <InputLabel>Dekad</InputLabel>
          <Select
            value={selectedLayer?.dekads[0] ?? dekads[0]}
            label="Dekad"
            onChange={(e) => handleChangeDekads(e, 0)}
            labelId="from-dekad"
          >
            {DEKADS.map(({ name, value }) => (
              <MenuItem key={`from-dekad-${name}`} value={`${value}`}>
                {name}{" "}
                <i>{` (${(Number(name) - 1) * 10 + 1}-${(Number(name) - 1) * 10 + 10})`}</i>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>
      <Stack sx={{ flex: 1 }} direction="row" gap={2}>
        <FormControl fullWidth sx={{ flex: 1 }}>
          <InputLabel id="to-month">Month</InputLabel>
          <Select
            value={selectedLayer?.months[1] ?? months[1]}
            label="Month"
            labelId="to-month"
            onChange={(e) => handleChangeMonths(e, 1)}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 150,
                },
              },
            }}
          >
            {MONTHS.map((month, i) => (
              <MenuItem key={`to-month-${month}`} value={`${i + 1}`}>
                {month}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth sx={{ flex: 1 }}>
          <InputLabel id="to-dekad">Dekad</InputLabel>
          <Select
            value={selectedLayer?.dekads[1] ?? dekads[1]}
            label="Dekad"
            labelId="to-dekad"
            onChange={(e) => handleChangeDekads(e, 1)}
          >
            {DEKADS.map(({ name, value }) => (
              <MenuItem key={`to-dekad-${name}`} value={`${value}`}>
                {name}{" "}
                <i>{` (${(Number(name) - 1) * 10 + 1}-${(Number(name) - 1) * 10 + 10})`}</i>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>
    </Stack>
  );
};

export default SelectCriticalWindow;
